import Breadcrumb from "components/Common/Breadcrumb"
import TableContainer from "components/Common/DataTableContainer"
import DashboardLoader from "components/Loader/DashboardLoader"
import DeleteModal from "pages/Calendar/DeleteModal"
import React, { useMemo, useState } from "react"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { selectUser } from "store/features/auth/authSlice"
import {
  useGetAllProjectsQuery,
  useDeleteProjectMutation,
  useGetClientByUserIdQuery,
} from "store/features/client/clientManagementApi"
import { useGetAllClientsQuery } from "store/features/client/clientManagementApi"
import { useGetAllDevelopersQuery } from "store/features/developer/developerManagementApi"
import ProjectWorkLogModal from "components/Modals/ProjectWorkLogModal"

const AllProjects = () => {
  const user = useSelector(selectUser)

  const { data: client, isLoading: isLoadingTwo } = useGetClientByUserIdQuery(
    user.id
  )

  const { data: projects, isLoading } = useGetAllProjectsQuery()
  const { data: clients = [] } = useGetAllClientsQuery()
  const { data: developers = [] } = useGetAllDevelopersQuery()
  const [deleteProject, { isLoading: deletingProject }] =
    useDeleteProjectMutation()

  const [deleteModal, setDeleteModal] = useState(false)
  const [workLogModal, setWorkLogModal] = useState(false)
  const [selectedProject, setSelectedProject] = useState(null)
  const [selectedProjectId, setSelectedProjectId] = useState(null)
  const [statusFilter, setStatusFilter] = useState("")
  const [priorityFilter, setPriorityFilter] = useState("")

  // Add this function for work log modal
  const showWorkLogModal = project => {
    setSelectedProject(project)
    setWorkLogModal(true)
  }

  const showDeleteModal = id => {
    setSelectedProjectId(id)
    setDeleteModal(true)
  }

  const handleDeleteProject = () => {
    deleteProject(selectedProjectId)
    setDeleteModal(false)
  }

  // Add this function for work log callback
  const handleWorkLogAdded = () => {
    // You can refetch projects or show a message if needed
    // refetch()
  }

  // Get client name by ID
  const getClientName = clientId => {
    const client = clients.find(client => client.id === clientId)
    return client ? client.company_name : "N/A"
  }

  // Get assigned team names
  const getTeamNames = teamIds => {
    if (!teamIds || !teamIds.length) return "No team assigned"
    const teamMembers = developers.filter(dev => teamIds.includes(dev.id))
    return teamMembers.map(dev => dev.nickname).join(", ")
  }

  // Get priority badge
  const getPriorityBadge = priority => {
    const priorityConfig = {
      1: { color: "danger", text: "High" },
      2: { color: "warning", text: "Medium" },
      3: { color: "success", text: "Low" },
      "": { color: "secondary", text: "Not Set" },
    }
    const config = priorityConfig[priority] || priorityConfig[""]
    return `<span class="badge bg-${config.color}">${config.text}</span>`
  }

  // Get status badge
  const getStatusBadge = status => {
    const statusConfig = {
      Pending: "warning",
      "In Progress": "primary",
      Completed: "success",
      "On Hold": "danger",
    }
    const color = statusConfig[status] || "secondary"
    return `<span class="badge bg-${color}">${status}</span>`
  }

  // Filter projects based on selected filters
  // const filteredProjects = useMemo(() => {
  //   if (!projects) return []

  //   return projects.filter(project => {
  //     const statusMatch = !statusFilter || project.status === statusFilter
  //     const priorityMatch =
  //       !priorityFilter || project.priority_status === priorityFilter
  //     return statusMatch && priorityMatch
  //   })
  // }, [projects, statusFilter, priorityFilter])

  // Filter projects based on selected filters and user role
  const filteredProjects = useMemo(() => {
    if (!projects) return []

    // Step 1: apply your existing status/priority filter
    let visibleProjects = projects.filter(project => {
      const statusMatch = !statusFilter || project.status === statusFilter
      const priorityMatch =
        !priorityFilter || project.priority_status === priorityFilter
      return statusMatch && priorityMatch
    })

    // Step 2: apply role-based filtering
    if (!user) return visibleProjects

    if (user.role === "super_admin" || user.role === "admin") {
      return visibleProjects
    }

    if (user.role === "project_manager") {
      return visibleProjects.filter(project =>
        project.assigned_project_manager?.includes(user.id)
      )
    }

    if (user.role === "developer") {
      return visibleProjects.filter(
        project =>
          project.assigned_frontend_dev?.includes(user.id) ||
          project.assigned_backend_dev?.includes(user.id)
      )
    }

    if (user.role === "designer") {
      return visibleProjects.filter(project =>
        project.assigned_designer?.includes(user.id)
      )
    }

    if (user.role === "client") {
      return visibleProjects.filter(project => project.client == client.id)
    }

    return []
  }, [projects, statusFilter, priorityFilter, user])

  // const columns = useMemo(
  //   () => [
  //     {
  //       header: "Project Name",
  //       accessorKey: "name",
  //       enableColumnFilter: false,
  //       enableSorting: true,
  //       cell: ({ row }) => (
  //         <div>
  //           <div className="fw-semibold">{row.original.name}</div>
  //           <small className="text-muted">{row.original.description}</small>
  //         </div>
  //       ),
  //     },
  //     {
  //       header: "Client",
  //       accessorKey: "client",
  //       enableColumnFilter: false,
  //       enableSorting: true,
  //       cell: ({ row }) => getClientName(row.original.client),
  //     },
  //     {
  //       header: "Budget",
  //       accessorKey: "budget",
  //       enableColumnFilter: false,
  //       enableSorting: true,
  //       cell: ({ row }) => `$${row.original.budget || "0.00"}`,
  //     },
  //     // {
  //     //   header: "Team",
  //     //   accessorKey: "assigned_team",
  //     //   enableColumnFilter: false,
  //     //   enableSorting: true,
  //     //   cell: ({ row }) => (
  //     //     <div>
  //     //       <small>{getTeamNames(row.original.assigned_team)}</small>
  //     //     </div>
  //     //   ),
  //     // },
  //     {
  //       header: "Start Date",
  //       accessorKey: "start_date",
  //       enableColumnFilter: false,
  //       enableSorting: true,
  //       cell: ({ row }) => row.original.start_date || "Not set",
  //     },
  //     {
  //       header: "End Date",
  //       accessorKey: "end_date",
  //       enableColumnFilter: false,
  //       enableSorting: true,
  //       cell: ({ row }) => row.original.end_date || "Not set",
  //     },
  //     // {
  //     //   header: "Status",
  //     //   accessorKey: "status",
  //     //   enableColumnFilter: false,
  //     //   enableSorting: true,
  //     //   cell: ({ row }) => (
  //     //     <div
  //     //       dangerouslySetInnerHTML={{
  //     //         __html: getStatusBadge(row.original.status),
  //     //       }}
  //     //     />
  //     //   ),
  //     // },
  //     // {
  //     //   header: "Transactions",
  //     //   accessorKey: "payment",
  //     //   enableColumnFilter: false,
  //     //   enableSorting: true,
  //     //   cell: ({ row }) => {
  //     //     const payments = row.original.payment || []
  //     //     if (payments.length === 0) return "No payments"

  //     //     return (
  //     //       <div>
  //     //         {payments.map((payment, index) => (
  //     //           <div key={payment.id}>
  //     //             <small className="fs-6">
  //     //               Payment {index + 1}:{" "}
  //     //               <span className="fw-semibold">
  //     //                 {payment.amount || "0.00"}
  //     //               </span>
  //     //             </small>
  //     //           </div>
  //     //         ))}
  //     //       </div>
  //     //     )
  //     //   },
  //     // },
  //     {
  //       header: "Transactions",
  //       accessorKey: "payment",
  //       enableColumnFilter: false,
  //       enableSorting: true,
  //       cell: ({ row }) => {
  //         const payments = row.original.payment || []
  //         const budget = parseFloat(row.original.budget || 0)
  //         const totalPaid = payments.reduce(
  //           (sum, payment) => sum + parseFloat(payment.amount || 0),
  //           0
  //         )
  //         const remaining = budget - totalPaid

  //         if (payments.length === 0) {
  //           return (
  //             <div className="fs-5">
  //               <small>No payments</small>
  //               <br />
  //               <small className="text-muted">
  //                 Budget: {budget.toFixed(0)}
  //               </small>
  //             </div>
  //           )
  //         }

  //         return (
  //           <div className="text-start fs-5">
  //             {payments.map((payment, index) => (
  //               <div
  //                 key={payment.id}
  //                 className="d-flex justify-content-between align-items-center"
  //               >
  //                 <small>Payment {index + 1}</small>
  //                 <small className="fw-semibold">
  //                   {parseFloat(payment.amount).toFixed(0)}
  //                 </small>
  //               </div>
  //             ))}

  //             <hr className="my-1" />

  //             <div className="d-flex justify-content-between align-items-center">
  //               <small className="fw-semibold text-success">Total Paid</small>
  //               <small className="fw-semibold text-success">
  //                 {totalPaid.toFixed(0)}
  //               </small>
  //             </div>

  //             <div className="d-flex justify-content-between align-items-center">
  //               <small className="fw-semibold text-danger">Remaining</small>
  //               <small className="fw-semibold text-danger">
  //                 {remaining.toFixed(0)}
  //               </small>
  //             </div>
  //           </div>
  //         )
  //       },
  //     },

  //     {
  //       header: "Priority",
  //       accessorKey: "priority_status",
  //       enableColumnFilter: false,
  //       enableSorting: true,
  //       cell: ({ row }) => (
  //         <div
  //           dangerouslySetInnerHTML={{
  //             __html: getPriorityBadge(row.original.priority_status),
  //           }}
  //         />
  //       ),
  //     },
  //     {
  //       header: "Progress",
  //       accessorKey: "progress",
  //       enableColumnFilter: false,
  //       enableSorting: true,
  //       cell: ({ row }) => (
  //         <div>
  //           <div className="progress mb-1" style={{ height: "6px" }}>
  //             <div
  //               className="progress-bar"
  //               role="progressbar"
  //               style={{ width: `${row.original.progress || 0}%` }}
  //               aria-valuenow={row.original.progress || 0}
  //               aria-valuemin="0"
  //               aria-valuemax="100"
  //             />
  //           </div>
  //           <small>{row.original.progress || 0}%</small>
  //         </div>
  //       ),
  //     },

  //     {
  //       header: "Action",
  //       accessorKey: "action",
  //       enableColumnFilter: false,
  //       enableSorting: true,
  //       cell: ({ row }) => (
  //         <div className="d-flex align-items-center gap-1">
  //           <Link
  //             to={`/projects/${row.original.id}`}
  //             className="btn btn-info btn-sm"
  //           >
  //             <i className="fas fa-eye"></i> View
  //           </Link>

  //           {(user?.role == "super_admin" || user?.role == "admin") && (
  //             <button
  //               className="btn btn-danger btn-sm"
  //               onClick={() => showDeleteModal(row.original.id)}
  //             >
  //               <i className="fas fa-trash"></i>
  //               {deletingProject ? "Deleting..." : "Delete"}
  //             </button>
  //           )}
  //         </div>
  //       ),
  //     },
  //   ],
  //   [clients, developers, deletingProject]
  // )

  const columns = useMemo(() => {
    const baseColumns = [
      {
        header: "Project Name",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div>
            <div className="fw-semibold">{row.original.name}</div>
            {/* <small className="text-muted">{row.original.description}</small> */}
          </div>
        ),
      },
    ]

    // Add admin-only columns
    if (user?.role === "super_admin" || user?.role === "admin") {
      baseColumns.push(
        {
          header: "Client",
          accessorKey: "client",
          enableColumnFilter: false,
          enableSorting: true,
          cell: ({ row }) => getClientName(row.original.client),
        },
        {
          header: "Budget",
          accessorKey: "budget",
          enableColumnFilter: false,
          enableSorting: true,
          cell: ({ row }) => `${row.original.budget || "0.00"}`,
        }
      )
    }

    // Add common columns for all users
    // baseColumns.push(
    //   {
    //     header: "Start Date",
    //     accessorKey: "start_date",
    //     enableColumnFilter: false,
    //     enableSorting: true,
    //     cell: ({ row }) => row.original.start_date || "Not set",
    //   },
    //   {
    //     header: "End Date",
    //     accessorKey: "end_date",
    //     enableColumnFilter: false,
    //     enableSorting: true,
    //     cell: ({ row }) => row.original.end_date || "Not set",
    //   }
    // )

    // Add admin-only columns
    if (user?.role === "super_admin" || user?.role === "admin") {
      baseColumns.push({
        header: "Transactions",
        accessorKey: "payment",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => {
          const payments = row.original.payment || []
          const budget = parseFloat(row.original.budget || 0)
          const totalPaid = payments.reduce(
            (sum, payment) => sum + parseFloat(payment.amount || 0),
            0
          )
          const remaining = budget - totalPaid

          if (payments.length === 0) {
            return (
              <div className="fs-5">
                <small>No payments</small>
                <br />
                <small className="text-muted">
                  Budget: {budget.toFixed(0)}
                </small>
              </div>
            )
          }

          return (
            <div className="text-start">
              {payments.map((payment, index) => (
                <div
                  key={payment.id}
                  className="d-flex justify-content-between mb-1"
                >
                  <div className="">
                    <small className="fs-6">Payment {index + 1}:</small>
                    <br />
                    <small className="">{payment?.date}</small>
                  </div>
                  <small className="fw-semibold fs-6">
                    {Number(
                      parseFloat(payment.amount).toFixed(0)
                    ).toLocaleString()}
                  </small>
                </div>
              ))}

              <hr className="my-1" />

              <div className="d-flex justify-content-between align-items-center">
                <small className="fw-semibold text-success">Total Paid</small>
                <small className="fw-semibold text-success">
                  {Number(totalPaid.toFixed(0)).toLocaleString()}
                </small>
              </div>

              <div className="d-flex justify-content-between align-items-center">
                <small className="fw-semibold text-danger">Remaining</small>
                <small className="fw-semibold text-danger">
                  {Number(remaining.toFixed(0)).toLocaleString()}
                </small>
              </div>
            </div>
          )
        },
      })
    }

    baseColumns.push(
      // {
      //   header: "Status",
      //   accessorKey: "status",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => <div className="">{row.original.status}</div>,
      // },
      // {
      //   header: "Priority",
      //   accessorKey: "priority_status",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => (
      //     <div
      //       dangerouslySetInnerHTML={{
      //         __html: getPriorityBadge(row.original.priority_status),
      //       }}
      //     />
      //   ),
      // },
      {
        header: "Progress",
        accessorKey: "progress",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div>
            <div className="progress mb-1" style={{ height: "6px" }}>
              <div
                className="progress-bar"
                role="progressbar"
                style={{ width: `${row.original.progress || 0}%` }}
                aria-valuenow={row.original.progress || 0}
                aria-valuemin="0"
                aria-valuemax="100"
              />
            </div>
            <small>{row.original.progress || 0}%</small>
          </div>
        ),
      },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div className="">
            <div className="d-flex align-items-center gap-1">
              <Link
                to={`/projects/${row.original.id}`}
                className="btn btn-info btn-sm"
              >
                <i className="fas fa-eye"></i>
              </Link>

              <button
                className="btn btn-success btn-sm"
                onClick={() => showWorkLogModal(row.original)}
                title="Add Work Log for this project"
              >
                <i className="fas fa-plus"></i>
              </button>

              {(user?.role == "super_admin" || user?.role == "admin") && (
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => showDeleteModal(row.original.id)}
                >
                  <i className="fas fa-trash"></i>
                  {/* {deletingProject ? "Deleting..." : "Delete"} */}
                </button>
              )}
            </div>
            <div className="d-flex align-items-center gap-1">
              {(user?.role == "super_admin" || user?.role == "admin") && (
                <Link
                  to={`/all-projects/invoice/${row.original.id}`}
                  className="btn btn-warning btn-sm mt-2"
                  title="View Invoice"
                >
                  <i className="fas fa-file-invoice"></i>
                </Link>
              )}
              {(user?.role == "super_admin" || user?.role == "admin") && (
                <Link
                  to={`/all-projects/money-receipt/${row.original.id}`}
                  className="btn btn-info btn-sm mt-2"
                  title="View Recept"
                >
                  <i className="fas fa-file-invoice"></i>
                </Link>
              )}
            </div>
          </div>
        ),
      }
    )

    return baseColumns
  }, [clients, developers, deletingProject, user])

  if (isLoading) {
    return <DashboardLoader />
  }

  return (
    <div className="page-content">
      <div className="container-fluid">

               <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
         
         {/* Breadcrumb Section */}
         <div>
           <Breadcrumb title="Projects" breadcrumbItem="Projects" />
         </div>
       
         {/* Action Buttons */}
         <div className="d-flex flex-wrap gap-2">
           
           <Link
             to="/worklog"
             className="btn btn-primary d-flex align-items-center px-3"
           >
             <i className="fas fa-plus me-2"></i>
             Work Log
           </Link>
       
         </div>
       </div>

        {/* Filters Section */}
        <div className="row mb-3">
          <div className="col-md-4">
            <label className="form-label">Filter by Status</label>
            <select
              className="form-select"
              value={statusFilter}
              onChange={e => setStatusFilter(e.target.value)}
            >
              <option value="">All Status</option>
              <option value="Pending">Pending</option>
              <option value="In Progress">In Progress</option>
              <option value="Completed">Completed</option>
              <option value="On Hold">On Hold</option>
            </select>
          </div>
          {/* <div className="col-md-4">
            <label className="form-label">Filter by Priority</label>
            <select
              className="form-select"
              value={priorityFilter}
              onChange={e => setPriorityFilter(e.target.value)}
            >
              <option value="">All Priority</option>
              <option value="1">High</option>
              <option value="2">Medium</option>
              <option value="3">Low</option>
            </select>
          </div> */}
          <div className="col-md-4 d-flex align-items-end">
            <button
              className="btn btn-light"
              onClick={() => {
                setStatusFilter("")
                setPriorityFilter("")
              }}
            >
              <i className="fas fa-times"></i> 
            </button>
          </div>
        </div>

        <TableContainer
          columns={columns}
          data={filteredProjects}
          isGlobalFilter={true}
          isPagination={true}
          SearchPlaceholder="Search Projects..."
          pagination="pagination"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />

        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteProject}
          loader={deletingProject}
          onCloseClick={() => setDeleteModal(false)}
        />

        {/* Work Log Modal */}
        <ProjectWorkLogModal
          isOpen={workLogModal}
          toggle={() => setWorkLogModal(false)}
          project={selectedProject}
          onWorkLogAdded={handleWorkLogAdded}
        />
      </div>
    </div>
  )
}

export default AllProjects
